import debounce from 'just-debounce';

import EventHandler from '@pixelunion/events';
import rimg from '@pixelunion/rimg-shopify'

export default class DynamicPromotions {
  constructor(section) {
    this.el = section.el;

    this.blocks = this.el.querySelectorAll('[data-promotion-block]');

    this.events = new EventHandler();

    this.blocks.forEach(block => {
      rimg.watch(block);

      this.events.register(block, 'rimg:load', () => this.checkBlockOverflow(block));
    });

    this.events.register(window, 'resize', debounce(() => {
      this.blocks.forEach(block => {
        this.checkBlockOverflow(block);
      });
    }, 100, true, true));
  }

  checkBlockOverflow(block) {
    const content = block.querySelector('[data-promotion-content]');
    const image = block.querySelector('[data-promotion-image] img');

    block.classList.remove('promotion-block--content-overflow');

    if (!image) {
      return;
    }

    const contentHeight = content.getBoundingClientRect().height;
    const imageHeight = image.getBoundingClientRect().height;

    if (contentHeight > imageHeight) {
      block.style.setProperty('--promotion-block-height', `${contentHeight}px`);
      block.classList.add('promotion-block--content-overflow');
    } else {
      block.style.setProperty('--promotion-block-height', `${imageHeight}px`);
      block.classList.remove('promotion-block--content-overflow');
    }
  }

  onSectionUnload() {
    this.events.unregisterAll();
  }
}
